import { Box, HStack, Text } from '@chakra-ui/react';
import React from 'react';

import { DEFAULT_TABLE_TEXT_WIDTH } from '@/constants/defaults';

interface PreviewCellProps {
  text: string;
  actionIconClickHandler?: () => void;
  className?: string;
  color?: string | null;
  colorText?: string | null;
  icon?: React.ReactNode;
  injectedCellContent?: React.JSX.Element;
  injectedContentOverridesText?: boolean;
  isSelected?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
}

const FULL_SIZE = '100%';

const APLTableCell = (props: PreviewCellProps): React.JSX.Element => {
  const {
    actionIconClickHandler = () => {
      console.log('Action icon click handler not defined');
    },
    className = 'APLTableCell',
    color = undefined,
    colorText = undefined,
    icon = null,
    injectedCellContent = null,
    injectedContentOverridesText = false,
    isSelected = false,
    onClick = () => {
      console.log('Click handler not defined');
    },
    text = '',
    style,
  } = props;

  const handleActionIconClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // Prevent the click event from propagating to the parent element
    event.stopPropagation();
    actionIconClickHandler();
  };

  const maxWidth = React.useMemo(() => {
    // Magic number 28 is 20px for the width of our color block (see below)
    // plus 8 px for half of the 16 px of padding between the text and color block
    // ensuring the row is 450 px in width
    // eslint-disable-next-line no-magic-numbers
    return color || colorText ? DEFAULT_TABLE_TEXT_WIDTH - 28 : DEFAULT_TABLE_TEXT_WIDTH;
  }, [color, colorText]);

  return (
    <Box className={className} w={FULL_SIZE} h={FULL_SIZE} onClick={onClick} style={style}>
      <HStack
        align={'left'}
        alignItems={'center'}
        backgroundColor={isSelected ? 'blue.400' : ''}
        h={FULL_SIZE}
        justifyContent={'space-between'}
        padding={'7px 10px'}
        paddingRight={'1rem'}
        w={'100%'}
      >
        {injectedContentOverridesText ? (
          injectedCellContent
        ) : (
          <>
            <Text
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              userSelect={'none'}
              whiteSpace={'nowrap'}
              width={`${maxWidth}px`}
            >
              {text}
            </Text>{' '}
            {injectedCellContent}
          </>
        )}
        {(color || colorText) && (
          <Box
            backgroundColor={color ? `${color} !important` : ' '}
            color={colorText ?? ''}
            h={'20px'}
            textAlign={'center'}
            w={'20px'}
          >
            {colorText && <Text>A</Text>}
          </Box>
        )}
        <Box className={'row-action-icon'} onClick={handleActionIconClick}>
          {icon}
        </Box>
      </HStack>
    </Box>
  );
};

export default APLTableCell;
